/**
 * @fileoverview Utilidades para manejo de fechas en el sistema
 * Centraliza formateo y conversiones para evitar inconsistencias
 */

/**
 * Convierte fecha de input a timestamp completo para API
 * @param {string} fechaInput - Fecha en formato YYYY-MM-DD
 * @param {'inicio'|'fin'} tipo - Si es inicio (00:00:00) o fin de día (23:59:59)
 * @returns {string|null} Timestamp completo o null si no hay fecha
 */
export function convertirFechaParaAPI(fechaInput, tipo = 'inicio') {
  if (!fechaInput || fechaInput.trim() === '') return null;
  
  const hora = tipo === 'inicio' ? '00:00:00' : '23:59:59';
  return `${fechaInput} ${hora}`;
}

/**
 * Valida que fecha_desde no sea mayor que fecha_hasta
 * @param {string} fechaDesde - Fecha desde
 * @param {string} fechaHasta - Fecha hasta
 * @returns {{valido: boolean, mensaje: string}}
 */
export function validarRangoFechas(fechaDesde, fechaHasta) {
  if (!fechaDesde || !fechaHasta) {
    return { valido: true, mensaje: '' };
  }
  
  const desde = new Date(fechaDesde);
  const hasta = new Date(fechaHasta);
  
  if (desde > hasta) {
    return { 
      valido: false, 
      mensaje: 'La fecha desde no puede ser mayor que la fecha hasta' 
    };
  }
  
  return { valido: true, mensaje: '' };
}

